import { useTheme, useMediaQuery } from '@material-ui/core';
import { useState, useEffect } from 'react';

const useGetViewPortDimensions = () => {
  const theme = useTheme();
  const mobileView = useMediaQuery(theme.breakpoints.down('md'));
    const [windowDimension, setWindowDimension] = useState({
        winWidth: window.innerWidth,
        winHeight: window.innerHeight,
      })
    
      const detectSize = () => {
        setWindowDimension({
          winWidth: window.innerWidth,
          winHeight: window.innerHeight,
        })
      };
    
      useEffect(() => {
        window.addEventListener('resize', detectSize);
        return () => {
          window.removeEventListener('resize', detectSize)
        }
      }, [windowDimension]);
    
    return { windowDimension, isMobile: mobileView }
}

export default useGetViewPortDimensions;
